import ShippingLabel from './ShippingLabel';
import GenerateRequest from './resources';
import { checkLicenseExpiry } from './ResourceValidations';

const req = GenerateRequest();

export default {
  async importSchedules(params) {
    try {
      await checkLicenseExpiry();
      const { data: schedule } = await req.post('schedule/importSchedule', params);
      return schedule;
    } catch (error) {
      console.error(`Error: ${error.message}`);
      throw error;
    }
  },
  async updateSchedule(params) {
    try {
      await checkLicenseExpiry();
      const { data: schedule } = await req.post('schedule/updateSchedule', params);
      return schedule;
    } catch (error) {
      console.error(`Error: ${error.message}`);
      throw error;
    }
  },
  async multiRowUpdate(params) {
    try {
      await checkLicenseExpiry();
      const { data } = await req.post('schedule/multiRowUpdate', params);
      return data;
    } catch (error) {
      console.error(`Error: ${error.message}`);
      throw error;
    }
  },
  async get(params = {}) {
    params = {
      limit: 25,
      page: 1,
      ...params,
    };
    try {
      await checkLicenseExpiry();
      const { data: schedules } = await req.get('schedule/getSchdules', { params });
      return schedules;
    } catch (e) {
      console.log(e);
      throw e;
      // TODO: Throw an error dialog box?
    }
  },
  async create(ship) {
    try {
      await checkLicenseExpiry();
      const { data: shipment } = await req.post('/shipping/new', ship);
      return new ShippingLabel(shipment);
    } catch (e) {
      console.log(e);
      throw (e);
    }
  },
  async archive(id) {
    try {
      await checkLicenseExpiry();
      const { data } = await req.post('shipping/archiveLabel', { id });
      return data;
    } catch (e) {
      throw e;
    }
  },
  async clone(card) {
    try {
      await checkLicenseExpiry();
      const { data: schedule } = await req.post('schedule/cloneSchedule', card, {
        params: { projectId: card.project._id },
      });
      return schedule;
    } catch (e) {
      // TODO: Add an alert here?
      console.log(e);
      throw e;
    }
  },
  async resolveConflict(params) {
    try {
      await checkLicenseExpiry();
      const { data: schedules } = await req.get('schedule/resolveConflict', { params });
      return schedules;
    } catch (e) {
      console.log(e);
      throw e;
      // TODO: Throw an error dialog box?
    }
  },
};
